import { connect } from "react-redux";
import { withRouter, RouteComponentProps } from "react-router";
import { createSelector } from "reselect";
import { Maybe } from "true-myth";

import {
  fetchPublishedSchedule,
  setScheduleDateBoundaries,
  SchedulingActionTypes,
} from "actions/scheduling";

import PublicSchedule from "components/schedule/public_schedule";
import { HASH_ACTION_REGEX, HASH_ACTIONS } from "helpers/schedule/print_pdf";
import { decodePublicContainerURL } from "helpers/schedule/scheduling_container";
import {
  selectOrderedSchedule,
  selectScheduling,
  IInteractiveView,
} from "store/select/scheduling";
import { IRootStateProps } from "types/reducers";
import { ISchedule } from "types/schedules";

interface IPropsFromState {
  publishedScheduleRequestStatus: IRootStateProps["scheduling"]["requestStatuses"]["publishedScheduleGet"];
  assignedSchedule: ISchedule;
  permalink: Maybe<string>;
  startDate: Maybe<Date>;
  endDate: Maybe<Date>;
  interactiveView: boolean;
  takeAction: HASH_ACTIONS;
}

interface IMapDispatchToProps {
  fetchPublishedSchedule: (
    startDate: Date,
    endDate: Date,
    location: string,
    forPublic: boolean
  ) => void;
  setScheduleDateBoundaries: (
    startDate: Date,
    endDate: Date
  ) => SchedulingActionTypes;
}

interface IPublicContainerProps
  extends IInteractiveView,
    RouteComponentProps<{
      urlInput: string;
    }> {}

const selectDecodedURL = (
  state: IRootStateProps,
  ownProps: IPublicContainerProps
) => {
  const { urlInput } = ownProps.match.params;
  return decodePublicContainerURL(urlInput);
};

const selectHashAction = (
  state: IRootStateProps,
  ownProps: IPublicContainerProps
) => {
  const { hash } = ownProps.location;
  const hashAction = HASH_ACTION_REGEX.exec(hash);
  return (hashAction ? hashAction[0] : HASH_ACTIONS.NONE) as HASH_ACTIONS;
};

const mapStateToPropsSelector = createSelector(
  selectOrderedSchedule,
  selectScheduling,
  selectDecodedURL,
  selectHashAction,
  (
    assignedSchedule,
    { requestStatuses },
    { permalink, startDate, endDate },
    takeAction
  ): IPropsFromState => {
    return {
      assignedSchedule,
      endDate,
      startDate,
      interactiveView: false,
      permalink,
      publishedScheduleRequestStatus: requestStatuses.publishedScheduleGet,
      takeAction,
    };
  }
);

const mapDispatchToProps: IMapDispatchToProps = {
  fetchPublishedSchedule,
  setScheduleDateBoundaries,
};

const PublicContainer = withRouter(
  connect(
    mapStateToPropsSelector,
    mapDispatchToProps
  )(PublicSchedule)
);

export default PublicContainer;
